const { parse, stringify } = JSON;
const isArray = Array.isArray;
const STRING = 'string';

class PatchableApiModel {
    constructor (data) {
        if (isArray(data)) {
            this.isPatch = true;
            this.diffs = data;
            return this;
        }

        const dataString = this.dataString = typeof data === STRING ? data : stringify(data || {});

        this.originalData = data;
        Object.assign(this, parse(dataString));
        this.parseData();
    }

    /**
     * Create a full copy of api response
     * @return {object} Clean clone of the current GumboModel instance
     */
    clone () {
        return new this.constructor(this.dataString);
    }

    create (data) {
        return new this.constructor(data);
    }

    parseData () {
        return this;
    }
}

PatchableApiModel.prototype.isPatch = false;
PatchableApiModel.prototype.diffs = null;

export default PatchableApiModel;